/* eslint-disable import/no-unused-modules */
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';

const mapStatus = (status: string, t: TFunction): string => {
  const statuses = {
    completed: t('Completed'),
    notCompleted: t('Not Completed'),
    expired: t('Expired'),
  };

  switch (status) {
    case 'completed':
      return statuses.completed;
    case 'not completed':
      return statuses.notCompleted;
    case 'expired':
      return statuses.expired;
    default:
      return status;
  }
};

export const useGetStatus = (): ((status: string) => string) => {
  const { t } = useTranslation('managerDashboard');
  return (status: string) => mapStatus(status, t);
};
